import { Button } from 'antd'
import { FC } from 'react'
import { RowNode } from '@/presentation/common/components/dataGrid/lib/api.types.ts'
import { useCrud } from '@/presentation/common/hooks/crud/useCrud.ts'
import { useMaintainerStore } from '@/presentation/common/store/zustand/maintainer.ts'
import { DeleteRentalMachineryFormProps } from '@/presentation/rentals/forms/types.ts'
import { useDeleteRentalsMachinery } from '@/presentation/rentals/hooks/useDeleteRentalsMachinery.ts'
import { QueryRentalsMachineryForTableResult } from '@/presentation/rentals/hooks/useQueryRentalsMachineryForTable.ts'

export const DeleteRentalMachineryForm: FC<DeleteRentalMachineryFormProps> = ({ onCancel, onFinish }) => {
  const messageApiKey = 'DeleteRentalMachineryForm-alert'
  const { submit, isSuccess, isLoading, isError, message } = useDeleteRentalsMachinery()
  useCrud({ messageApiKey, message, isSuccess, isLoading, isError })

  const selectionNodes = useMaintainerStore(state => state.selectionV2)
  const ids = selectionNodes.map((node: RowNode<QueryRentalsMachineryForTableResult['items'][0]>) => node.data.id)

  const onConfirmDelete = async () => {
    if (isLoading) {
      return
    }

    await submit({ ids })
    onFinish?.call(this)
  }

  return (
    <>
      <p className="text-center mb-6">
                Está apunto de eliminar las maquinarias seleccionadas ({ids.length}).<br/>
                ¿Desea continuar con esta operación?
      </p>
      <div className="flex justify-center gap-2.5 pb-2">
        <Button size="small" type="primary" onClick={onCancel}>Cancelar</Button>
        <Button size="small" type="primary" danger onClick={onConfirmDelete}
          disabled={isLoading}>Eliminar</Button>
      </div>
    </>
  )
}
